import { render, staticRenderFns } from "./PointInfoWin.vue?vue&type=template&id=b5e855c0&scoped=true"
import script from "./PointInfoWin.vue?vue&type=script&lang=js"
export * from "./PointInfoWin.vue?vue&type=script&lang=js"
import style0 from "./PointInfoWin.vue?vue&type=style&index=0&id=b5e855c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e855c0",
  null
  
)

export default component.exports